//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

export default function parseUrl(url: string): HTMLHyperlinkElementUtils {
  const a = document.createElement('a');
  a.href = url;
  return a;
}
